import type * as React from "react";
import { cn } from "./cn";

// The mock's .select: a native select styled like the inputs (keyboard and mobile friendly).
export function NativeSelect({ className, ...props }: React.ComponentProps<"select">) {
  return (
    <select
      data-slot="native-select"
      className={cn(
        "h-9 min-w-0 rounded-sm border border-field-border bg-surface pr-2 pl-2.5 text-base text-ink transition-colors hover:border-ink-3 disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
}
